import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

// Módulos
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { LOCALE_ID, NgModule, provideAppInitializer, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AppRoutingModule } from './app-routing.module';
import { MatIconModule } from '@angular/material/icon';

// Pipes
import { CurrencyFormat } from './core/pipes/currencyFormat.pipe';

// Directivas
import { LazyLoadImgDirective } from './core/directives/lazy-load-img.directive';

// Servicios
import { CookieService } from 'ngx-cookie-service';
import { CanActiveViaAuthGuard } from './core/services/auth-guard.service';
import { FeatureFlagsService } from './core/services/feature-flags.service';
import { RuntimeConfigService } from './core/config/services/runtime-config.service';
import { CustomRouteReuseStrategy } from './core/services/custom-route-reuse-strategy';

// Componentes
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { HomeComponent } from './pages/home/home.component';
import { FooterComponent } from './shared/ui/organisms/app-footer/footer.component';
import { SitemapComponent } from './pages/sitemap/sitemap.component';
import { FaqComponent } from './pages/faq/faq.component';
import { HeaderComponent } from './shared/ui/organisms/app-header/header.component';
import { LandingOfferComponent } from './pages/landing-offer/landing-offer.component';
import { EducationBlogComponent } from './pages/education-blog/education-blog.component';
import { EducationBlogPostComponent } from './pages/education-blog/education-blog-post/education-blog-post.component';
import { SharedModule } from "./modules/shared/shared.module";
import { ModalComponent } from './shared/modal/modal.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { ConnectModalComponent } from './shared/bc-connect/connect-modal/connect-modal.component';
import { RecommendationsModalComponent } from './shared/bc-connect/connect-modal/bancolombia/recommendations-modal/recommendations-modal.component';
import { TestimonialsComponent } from './shared/testimonials/testimonials.component';
import { UiAccordionItemMoleculeComponent } from './shared/ui/molecules/ui-accordion-item/ui-accordion-item.component';




registerLocaleData(localeEs, 'es');

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        CurrencyFormat,
        ErrorPageComponent,
        SitemapComponent,
        FaqComponent,
        HeaderComponent,
        LandingOfferComponent,
        EducationBlogComponent,
        EducationBlogPostComponent,
        ModalComponent,
        LoaderComponent,
        ConnectModalComponent
    ],
    // {provide: ErrorHandler, useClass : ErrorHandlerService}
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        NgxCaptchaModule,
        SharedModule,
        MatIconModule,
        TestimonialsComponent,
        RecommendationsModalComponent,
        UiAccordionItemMoleculeComponent,
        FooterComponent,
        LazyLoadImgDirective
    ],
    providers: [
        CanActiveViaAuthGuard,
        CookieService,
        { provide: LOCALE_ID, useValue: 'es' },
        { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
        provideAppInitializer(() => inject(FeatureFlagsService).load()),
        provideAppInitializer(() => inject(RuntimeConfigService).initialize()),
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ]
})
export class AppModule { }
